import { createFileRoute, Outlet, useMatches } from '@tanstack/react-router'
import { invoicesSearchSchema } from '@/features/invoices/model'
import { InvoicesScreen } from '@/features/invoices/routes/invoices-screen'

export const Route = createFileRoute('/invoices')({
  // The list's group, search and page live in the address (src/features/invoices/model.ts).
  validateSearch: invoicesSearchSchema,
  component: InvoicesLayout,
})

function InvoicesLayout() {
  // An invoice's page owns the whole screen; the list shows when none is open.
  const matches = useMatches()
  const hasChild = matches.some((match) => match.routeId === '/invoices/$invoiceId')
  const search = Route.useSearch()
  return hasChild ? <Outlet /> : <InvoicesScreen search={search} />
}
